<script>
/**
 * FormField
 * ---------------------------------------------------------------------------
 * Celda de formulario responsive con etiqueta opcional. Por defecto ocupa:
 *   xs: 12 (full)  ->  md: 6 (dos por fila)  ->  lg: 4 (tres por fila)
 * que es un reparto seguro y legible en cualquier dispositivo. Se puede
 * sobreescribir por breakpoint con la prop `cols`.
 *
 * Es solo un envoltorio de layout: el input/select va en el slot por defecto
 * con su `v-model` y validaciones intactas.
 *
 * Props:
 *   label  -> texto de etiqueta (opcional; o usar el slot `label`).
 *   labelFor -> id del control para el atributo `for`.
 *   cols   -> objeto { xs, sm, md, lg, xl } con el nº de columnas (1-12).
 *             Solo se aplican las claves provistas; el resto usa defaults.
 *   required -> muestra un asterisco en la etiqueta.
 *
 * Uso:
 *   <FormField label="Teléfono" :cols="{ md: 6, lg: 3 }">
 *     <input v-model="tel" class="form-control" />
 *   </FormField>
 */
const DEFAULT_COLS = { xs: 12, md: 6, lg: 4 };

export default {
  name: "FormField",
  props: {
    label: { type: String, default: "" },
    labelFor: { type: String, default: null },
    cols: {
      type: Object,
      default: () => ({}),
    },
    required: { type: Boolean, default: false },
  },
  computed: {
    colClasses() {
      const merged = { ...DEFAULT_COLS, ...this.cols };
      const classes = [];
      Object.keys(merged).forEach((bp) => {
        const n = merged[bp];
        if (!n) return;
        classes.push(bp === "xs" ? `col-${n}` : `col-${bp}-${n}`);
      });
      return classes;
    },
    hasLabel() {
      return !!this.label || !!this.$slots.label;
    },
  },
};
</script>

<template>
  <div :class="colClasses" class="rwd-form-field">
    <div class="mb-3">
      <label v-if="hasLabel" :for="labelFor" class="form-label">
        <slot name="label">{{ label }}</slot>
        <span v-if="required" class="text-danger">*</span>
      </label>
      <slot />
    </div>
  </div>
</template>
